import { render, staticRenderFns } from "./banner-text-card.vue?vue&type=template&id=0c3fc422"
import script from "./banner-text-card.vue?vue&type=script&lang=js"
export * from "./banner-text-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports